import type { ComponentProps } from "react";
import { NavGroup } from "@/components/layout/nav-group";
import { TeamSwitcher } from "@/components/layout/team-switcher";
import { NavUser } from "@/components/nav-user";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarTrigger,
	useSidebar,
} from "@/components/ui/sidebar";
import { sidebarData } from "./data/sidebar-data";

export function AppSidebar({ ...props }: ComponentProps<typeof Sidebar>) {
	const { state } = useSidebar();

	return (
		<Sidebar collapsible="icon" variant="floating" {...props}>
			<SidebarHeader
				className={`${
					state === "collapsed"
						? "flex flex-col items-center space-y-2"
						: "flex w-full flex-row flex-nowrap items-center justify-between"
				}`}
			>
				<TeamSwitcher />
				<SidebarTrigger className="scale-125 sm:scale-100" />
			</SidebarHeader>
			<SidebarContent>
				{sidebarData.navGroups.map((group) => (
					<NavGroup key={group.title} {...group} />
				))}
			</SidebarContent>
			<SidebarFooter>
				<NavUser />
			</SidebarFooter>
		</Sidebar>
	);
}
